import { useEbbne, useEbbnenContext } from "@solidwhite/ebbnen";
import { useMemo } from "react";

type VisibleWhenType = "active" | "active-and-below" | "visible" | "visible-and-below" | "selectable";

interface VisibleWithEbbneProps {
  children?: React.ReactNode;
  visibleWhen?: VisibleWhenType;
  hideWhenBelow?: boolean;
}

const VisibleWithEbbne = ({ children, visibleWhen = "active", hideWhenBelow = false }: VisibleWithEbbneProps) => {
  const { route, active, visible, selectable, layer } = useEbbne();
  const { locationHook, currentLayer } = useEbbnenContext();
  const [location, _] = locationHook();

  const isVisible = useMemo(() => {
    switch (visibleWhen) {
      case "active":
        return active;

      case "active-and-below":
        return location.startsWith(route);

      case "visible":
        if (hideWhenBelow && visible) return currentLayer <= layer;
        return visible;

      case "visible-and-below":
        var below = location.startsWith(route) && currentLayer > layer;
        var mounted = visible || below;
        return mounted;

      case "selectable":
        return selectable;

      default:
        return false;
    }
  }, [location, route, active, visible, selectable]);

  return <group visible={isVisible}>{children}</group>;
};

export default VisibleWithEbbne;
